import React from 'react' ;
const GenderDetection = ({GenderDetect}) => {
    return(
        <div className='center'>
        <div className='f1 h1 center grow pa4'>
             {GenderDetect}
        </div>
        </div>
    );
}
export default GenderDetection;